import Vue from 'vue';
import VueRouter from 'vue-router';

import SearchResultsWrapper from '@/apps/search/001/components/SearchResultsWrapper';
import AdvancedSearch from '@/apps/search/001/components/AdvancedSearch';
import { getSearchBaseUrl } from '@/utils/helpers';

Vue.use(VueRouter);

const routes = [
    {
        path: '/advanced-search',
        name: 'advancedsearch',
        component: AdvancedSearch,
    },
    {
        path: '*',
        name: 'jobs',
        component: SearchResultsWrapper,
    },  
];

const router = new VueRouter({
    mode: 'history',
    base: getSearchBaseUrl(),
    routes,
});

Vue.use(router);

export default router;
